import { connect } from 'react-redux';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Component from './Component';

export default connect(mapStateToProps, mapDispatchToProps)(Component);
